// src/services/aiService.js

// Fonction pour créer ou récupérer un sessionId unique côté client
export function getSessionId() {
  let sessionId = localStorage.getItem("ai_session_id");
  if (!sessionId) {
    // Crée un sessionId unique
    sessionId = "user-" + Math.random().toString(36).substr(2, 9); // ex: user-5g8h3k2p
    localStorage.setItem("ai_session_id", sessionId);
    console.log("Nouvelle sessionId générée:", sessionId);
  } else {
    console.log("SessionId existante récupérée:", sessionId);
  }
  return sessionId;
}

// Envoyer un message au backend AI
export async function askAI(message, sessionId = null) {
  if (!sessionId) {
    sessionId = getSessionId();
  }

  console.log("askAI called with:", { message, sessionId });

  try {
    const payload = { message: message, session_id: sessionId };
    console.log("Payload envoyé au backend:", payload);

    const response = await fetch(`${process.env.REACT_APP_APIURL}/ai/chat`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    console.log("Response raw:", response);

    const data = await response.json();
    console.log("Data reçue du backend:", data);

    return data.answer || "Désolé, pas de réponse pour le moment.";
  } catch (error) {
    console.error("Erreur AI:", error);
    return "Désolé, une erreur est survenue en communiquant avec l’agent.";
  }
}

// 🔹 Nouvelle fonction pour récupérer toute la conversation existante
export async function getConversation(sessionId = null) {
  if (!sessionId) {
    sessionId = getSessionId();
  }

  console.log("Récupération conversation pour sessionId:", sessionId);

  try {
    const response = await fetch(`${process.env.REACT_APP_APIURL}/ai/conversation/${sessionId}`);
    console.log("Response raw conversation:", response);

    const data = await response.json();
    console.log("Data conversation reçue:", data);

    return data.conversation || [];
  } catch (error) {
    console.error("Erreur récupération conversation:", error);
    return [];
  }
}